import { Link } from "react-router-dom";
import MarketingNav from "@/components/MarketingNav";
import MarketingFooter from "@/components/MarketingFooter";
import PlatformSupportChat from "@/components/PlatformSupportChat";

/**
 * Shared wrapper for all legal / static pages (About, Contact, Terms,
 * Privacy, Refund). Renders the marketing nav + footer around a centered
 * article with a consistent heading hierarchy. The right-rail is used
 * as an in-page table of contents on wider viewports.
 */
export default function LegalLayout({ title, updated, toc, children }) {
    return (
        <div className="min-h-screen bg-[#F5F8FA] text-[#17212B]">
            <MarketingNav />
            <main className="max-w-6xl mx-auto px-5 sm:px-8 py-14">
                <header className="mb-10 max-w-3xl">
                    <div className="text-xs uppercase tracking-[0.32em] text-[#0F766E] font-semibold">Legal &amp; Compliance</div>
                    <h1 className="mt-2 text-3xl sm:text-4xl lg:text-5xl font-bold text-[#123B5D] tracking-tight" data-testid="legal-page-title">
                        {title}
                    </h1>
                    {updated ? (
                        <div className="mt-3 text-sm text-[#17212B]/60">Last updated: {updated}</div>
                    ) : null}
                </header>
                <div className="grid grid-cols-1 lg:grid-cols-[1fr_240px] gap-10">
                    <article className="prose prose-slate max-w-3xl prose-headings:text-[#123B5D] prose-h2:text-2xl prose-h2:mt-10 prose-h2:mb-3 prose-h3:text-lg prose-h3:mt-6 prose-h3:mb-2 prose-p:leading-relaxed prose-li:leading-relaxed prose-a:text-[#0F766E] prose-a:font-semibold">
                        {children}
                    </article>
                    {toc?.length ? (
                        <aside className="hidden lg:block">
                            <div className="sticky top-24 border-l border-[#123B5D]/10 pl-5">
                                <div className="text-[11px] uppercase tracking-[0.28em] text-[#17212B]/50 font-semibold mb-3">
                                    On this page
                                </div>
                                <ul className="space-y-2 text-sm">
                                    {toc.map((t) => (
                                        <li key={t.id}>
                                            <a href={`#${t.id}`} className="text-[#123B5D] hover:text-[#0F766E]">
                                                {t.label}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                                <div className="mt-6 pt-6 border-t border-[#123B5D]/10 text-xs text-[#17212B]/60 space-y-2">
                                    <div className="font-semibold text-[#123B5D]">Questions?</div>
                                    <div>Support: <a href="tel:+917722090290" className="text-[#0F766E]">+91 7722090290</a></div>
                                    <div><Link to="/contact" className="text-[#0F766E] font-semibold">Contact us →</Link></div>
                                </div>
                            </div>
                        </aside>
                    ) : null}
                </div>
            </main>
            <MarketingFooter />
            <PlatformSupportChat />
        </div>
    );
}
